import { createApp } from 'vue'
import '@/style/reset.scss'
import App from './App.vue'

const initApp = async () => {
  const app = createApp(App)
  app.mount('#app')
  ;(document.querySelector('.starting-loading') as HTMLDivElement).style.display = 'none'
}

initApp()
